import { action, observable } from 'mobx'

export const rootStore = observable({
  me: null,
  favBj: [],
  favWinee: [],
  gameNotice: '',
  dropBj: -1,
  dropAnalyst: -1,
  dropBj1: -1,
  dropWinee: -1,
  chatInfo: null,
  chatCnt: 0,

  signIn: user => {
    rootStore.me = user
    sessionStorage.setItem('user', JSON.stringify(user))
  },

  signOut: () => {
    rootStore.me = null
    sessionStorage.setItem('user', null)
    localStorage.removeItem('loginType')
    rootStore.setFavBj([])
    rootStore.setFavWinee([])
    rootStore.setAlarmCount(0)
    rootStore.chatInfo = null
  },

  setFavBj: list => {
    rootStore.favBj = list
    sessionStorage.setItem('favBj', JSON.stringify(list))
  },

  setFavWinee: list => {
    rootStore.favWinee = list
    sessionStorage.setItem('favWinee', JSON.stringify(list))
  },

  setChatInfo: info => {
    rootStore.chatInfo = info
  },

  setChatCnt: cnt => {
    rootStore.chatCnt = cnt
  },

  setGameNotice: notice => {
    rootStore.gameNotice = notice
  },

  setDropbj: drop => {
    rootStore.dropBj = drop
  },

  setDropAnalyst: drop => {
    rootStore.dropAnalyst = drop
  },

  setDropbj1: drop => {
    rootStore.dropBj1 = drop
  },

  setDropWinee: drop => {
    rootStore.dropWinee = drop
  },
  setAlarmCount: cnt => {
    rootStore.alramCount = cnt
  },


  get getMe() {
    if (rootStore.me == null) {
      try {
        rootStore.me = JSON.parse(sessionStorage.getItem('user'))
      } catch (e) {
        console.log(e)
      }
    }
    return rootStore.me
  },

  get getFavBj() {
    if (rootStore.favBj == null || rootStore.favBj.length === 0) {
      try {
        rootStore.favBj = JSON.parse(sessionStorage.getItem('favBj'))
      } catch (e) {
        console.log(e)
      }
    }
    return rootStore.favBj
  },

  get getFavWinee() {
    if (rootStore.favWinee == null || rootStore.favWinee.length === 0) {
      try {
        rootStore.favWinee = JSON.parse(sessionStorage.getItem('favWinee'))
      } catch (e) {
        console.log(e)
      }
    }
    return rootStore.favWinee
  },

  get getChatInfo() {
    return rootStore.chatInfo
  },

  get getChatCnt() {
    return rootStore.chatCnt
  },

  get isSignedIn() {
    return rootStore.getMe !== null
  },

  get token() {
    return rootStore.getMe?.mb_token ?? ''
  },

  get getDropbj() {
    return rootStore.dropBj
  },

  get getDropAnalyst() {
    return rootStore.dropAnalyst
  },

  get getDropbj1() {
    return rootStore.dropBj1
  },

  get getDropWinee() {
    return rootStore.dropWinee
  },

  get getAlarmCount() {
    return rootStore.alramCount ?? 0;
  },
}, {
  signIn: action,
  signOut: action,
  setFavBj: action,
  setFavWinee: action,
  setChatInfo: action,
  setChatCnt: action,
  setDropbj: action,
  setDropAnalyst: action,
  setDropbj1: action,
  setDropWinee: action,
  setAlarmCount : action,
})
